export type Lang = 'de' | 'en';

export interface Strings {
  langName: string;
  switchTo: string;
  nav: { privacy: string; imprint: string; allTools: string };
  hero: { title: string; subtitle: string; localBadge: string };
  ui: {
    encode: string;
    decode: string;
    input: string;
    output: string;
    copy: string;
    copied: string;
    plainPlaceholder: string;
    b64Placeholder: string;
    b64Error: string;
    fileTitle: string;
    fileHint: string;
  };
  seo: {
    aboutTitle: string;
    aboutBody: string;
    faqTitle: string;
    faq: { q: string; a: string }[];
  };
  footer: { rights: string; noStorage: string };
}

const de: Strings = {
  langName: 'Deutsch',
  switchTo: 'English',
  nav: { privacy: 'Datenschutz', imprint: 'Impressum', allTools: 'Alle Tools' },
  hero: {
    title: 'Base64-Converter',
    subtitle:
      'Base64 für Text und Dateien kodieren und dekodieren — alles lokal im Browser. Nichts wird gesendet.',
    localBadge: '100 % lokal · kostenlos',
  },
  ui: {
    encode: 'Kodieren',
    decode: 'Dekodieren',
    input: 'Eingabe',
    output: 'Ergebnis',
    copy: 'Kopieren',
    copied: 'Kopiert',
    plainPlaceholder: 'Text eingeben…',
    b64Placeholder: 'Base64 einfügen…',
    b64Error: 'Ungültiges Base64.',
    fileTitle: 'Datei → Data-URL',
    fileHint: 'Datei hierher ziehen oder klicken — bleibt lokal',
  },
  seo: {
    aboutTitle: 'Base64 sicher und lokal verarbeiten',
    aboutBody:
      'Dieses Werkzeug kodiert und dekodiert Base64 für Text und Dateien ausschließlich lokal in deinem Browser. Deine Daten werden nicht an einen Server gesendet oder gespeichert.',
    faqTitle: 'Häufige Fragen',
    faq: [
      {
        q: 'Werden meine Daten gesendet?',
        a: 'Nein. Die Kodierung/Dekodierung läuft vollständig lokal im Browser.',
      },
      {
        q: 'Funktioniert Base64 mit Umlauten/Emojis?',
        a: 'Ja. Text wird UTF-8-sicher kodiert und dekodiert.',
      },
      {
        q: 'Kann ich Dateien kodieren?',
        a: 'Ja. Lade eine Datei hoch und erhalte ihre Base64-Data-URL — die Datei verlässt den Browser nicht.',
      },
    ],
  },
  footer: {
    rights: 'Kostenlose Tools von ecosquirrel.',
    noStorage: 'Keine serverseitige Speicherung. Alles läuft lokal im Browser.',
  },
};

const en: Strings = {
  langName: 'English',
  switchTo: 'Deutsch',
  nav: { privacy: 'Privacy', imprint: 'Imprint', allTools: 'All tools' },
  hero: {
    title: 'Base64 Converter',
    subtitle:
      'Encode and decode Base64 for text and files — all locally in your browser. Nothing is sent.',
    localBadge: '100% local · free',
  },
  ui: {
    encode: 'Encode',
    decode: 'Decode',
    input: 'Input',
    output: 'Result',
    copy: 'Copy',
    copied: 'Copied',
    plainPlaceholder: 'Enter text…',
    b64Placeholder: 'Paste Base64…',
    b64Error: 'Invalid Base64.',
    fileTitle: 'File → data URL',
    fileHint: 'Drop a file here or click — stays local',
  },
  seo: {
    aboutTitle: 'Process Base64 securely and locally',
    aboutBody:
      'This tool encodes and decodes Base64 for text and files exclusively in your browser. Your data is not sent to a server or stored.',
    faqTitle: 'Frequently asked questions',
    faq: [
      {
        q: 'Is my data sent anywhere?',
        a: 'No. Encoding/decoding runs entirely locally in the browser.',
      },
      {
        q: 'Does Base64 work with accents/emojis?',
        a: 'Yes. Text is encoded and decoded in a UTF-8-safe way.',
      },
      {
        q: 'Can I encode files?',
        a: 'Yes. Upload a file to get its Base64 data URL — the file never leaves your browser.',
      },
    ],
  },
  footer: {
    rights: 'Free tools by ecosquirrel.',
    noStorage: 'No server-side storage. Everything runs locally in your browser.',
  },
};

export const STRINGS: Record<Lang, Strings> = { de, en };
